
<template>

    <div class="about">
        <p></p>  <p></p>
        <img alt="Vue logo" src="../assets/mm-logo.png">
        <h1> </h1>
        <div class="p-3 mb-2 bg-danger text-white"><H1><B>BKash Exchange Rate</B></H1></div>
        <table class="table table-hover">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Country</th>
                <th scope="col">Rate</th>
                <th scope="col">Last Update On</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(exrate, idx) in bkashRate" :key="idx">
                <th scope="row">{{idx+1}}</th>
                <td>{{exrate.country}}</td>
                <td>RM 1= {{exrate.currencyCode}} {{exrate.rate}} <b>{{exrate.remark}}</b></td>
                <td>{{exrate.dtUpdated}}</td>
                </tr>
            </tbody>
        </table>
        <p><em>Version: 0.0.2</em></p>

    </div>
</template>

<script>

/* eslint-disable */
import axios from 'axios';
import https from 'https';


export default {
  data() {
      return {
          rates:[],
          apiUrl: 'https://kadarapiext.mobile-money.com.my/rate'
      }
  },
  computed: {
    bkashRate: function () {
        return this.rates.filter(function (rate) {
        return rate.country === "Bangladesh (BKash)";
        })
    }
  },
  mounted: function() {
      //https.globalAgent.options.rejectUnauthorized = false;
      //axios.get('http://localhost:5370/rate')
        //process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

/*
    const instance = axios.create({
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        })
    });

    instance.get(this.apiUrl)
    .then(response => {
        this.rates = response.data.recordset;
        console.log(response);
        console.log(this.apiUrl);
    })
    .catch(error => {
        console.log(error);
    });
*/

/*
      const agent = new https.Agent({
          rejectUnauthorized: false
        });

    axios.get(this.apiUrl, { httpsAgent: agent })
        .then(response => {
            this.rates = response.data.recordset;
            console.log(response);
            console.log(this.apiUrl);
        })
        .catch(error => {
            console.log(error);
        });
*/

      axios.get(this.apiUrl)
        .then(response => {
            this.rates = response.data.recordset;
            console.log(response);
            console.log(this.apiUrl);
        })
        .catch(error => {
            console.log(error);
        });

  }
}
</script>
